import { initializeComponents } from "~/utils/bundle_utils";
import store from '~/base_store';
import FlashMessage from './components/ps_flash_message';
import HiddenPasswordInputs from './components/ps_password_inputs';
import PasswordSettingsModule from './store';
import PasswordSettingsPage from './components/ps_org_password_settings_page';
import ResetPasswordForm from './components/ps_reset_password_form';
import UpdatePasswordForm from './components/ps_update_password_form';
import UpdateExpiredPasswordForm from './components/ps_expired_password_update_form';
import OrgSecurityQuestionSettingsForm
    from "~/bundles/password_settings/components/ps_org_security_question_settings_form";
import OrgSecurityQuestionsForm
    from "~/bundles/password_settings/components/ps_org_security_questions_form";
import SecurityQuestionAnswersForm from "~/bundles/password_settings/components/ps_security_question_answers_form";

$(() => {
    store.registerModule('passwordSettings', PasswordSettingsModule);

    initializeComponents('.vue-reset-password-form', ResetPasswordForm);
    initializeComponents('.vue-update-password-form', UpdatePasswordForm);
    initializeComponents('.vue-expired-password-update-form', UpdateExpiredPasswordForm);
    initializeComponents('.vue-up-hidden-inputs', HiddenPasswordInputs);
    initializeComponents('.vue-password-message', FlashMessage);
    initializeComponents('.vue-org-password-settings-page', PasswordSettingsPage);
    initializeComponents('.vue-org-security-question-settings-form', OrgSecurityQuestionSettingsForm);
    initializeComponents('.vue-org-security-questions-form', OrgSecurityQuestionsForm);
    initializeComponents('.vue-security-question-answers-form', SecurityQuestionAnswersForm);
});
